import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import ImpliedStrategy from "components/UnifiedProject/RealityCheck/ImpliedStrategy";

import * as projectReducer from "containers/Project/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as unifiedProjectReducer from "containers/UnifiedProject/reducer";

export const getRunId = (props) =>
  props && props.id
    ? props.id
    : props && props.match && props.match.params && props.match.params.runId
      ? props.match.params.runId
      : 2860;

class ImpliedStrategyContainer extends React.PureComponent {
  render() {
    return <ImpliedStrategy {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getRunId(ownProps);

  const retId = ownProps.isEditBlueprint
    ? ownProps.editBlueprintId
    : ownProps.optimized && ownProps.optimized.innerId !== undefined
      ? ownProps.optimized.innerId
      : id;

  return {
    updatePrimaryBusinessConstraintType: (type) =>
      dispatch(setupReducer.updatePrimaryBusinessConstraintType(retId, type))
  };
};

const mapStateToProps = (state, ownProps) => {
  const id = getRunId(ownProps);

  const isEditBlueprint = unifiedProjectReducer.getIsEditBlueprint(state, id);

  const setup = setupReducer.getSetup(state, id);

  const optimized = projectReducer.getOptimized(state, id);

  const editBlueprintId = unifiedProjectReducer.getEditBlueprintRunId(state, id);

  const runId = isEditBlueprint
    ? editBlueprintId
    : optimized && optimized.innerId !== undefined
      ? optimized.innerId
      : id;

  const businessConstraints = setupReducer.getBusinessConstraints(state, id, runId);
  const impliedBusinessConstraints = setupReducer.getImpliedBusinessConstraints(state, id, runId);

  return {
    isEditBlueprint: isEditBlueprint,
    runId: runId,
    setup: setup,
    businessConstraints: businessConstraints,
    impliedBusinessConstraints: impliedBusinessConstraints,
    constraintTypeLabelMap: setupReducer.getConstraintTypeLabelMap(state, runId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ImpliedStrategyContainer);
